import {Configuration} from "@azure/msal-browser";

export const authConfig : Configuration =  {
    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID}`,
        authority: process.env.REACT_APP_SSO_AUTHORITY,
        redirectUri: process.env.REACT_APP_SSO_SIGN_IN_REDIRECT_URL,
    }
};

export const loginRequest = {
    scopes: [process.env.REACT_APP_CLIENT_ID] // the scope for login should be the client app, the scope for API usage should be the server token
};

export const apiTokenScopes = {
    scopes: `${process.env.REACT_APP_TOKEN_SCOPES}`.split(",")
}